import React from 'react';
import { Modal, Box, Typography, Button, Link } from '@mui/material';

const ExpirationModal = ({ isOpen, onClose }) => {
    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    textAlign: 'center'
                }}
            >
                <span className="material-symbols-outlined" style={{fontSize: '3rem', color: 'var(--color-danger)', marginBottom: '1rem'}}>
                    error
                </span>
                <Typography variant="h6" gutterBottom>
                    Cuenta Expirada o Suspendida
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Tu cuenta ha sido suspendida o ha expirado. Por favor, comunícate con
                    <strong> Leptón </strong> para obtener más información.
                </Typography>
                <Link
                    href="https://www.lepton-seguridad.com/"
                    target="_blank"
                    rel="noopener"
                    sx={{ display: 'block', mb: 3, color: 'primary.main', fontWeight: 'bold' }}
                >
                    Ir a la página de Leptón
                </Link>
                <Button variant="contained" color="primary" onClick={onClose}>
                    Aceptar
                </Button>
            </Box>
        </Modal>
    );
};

export default ExpirationModal;
